import React from "react";
import Select from "react-select";
import { Image } from "react-bootstrap";
import { TbRefresh } from "react-icons/tb";

import {
  conversationSubFilters,
  MENU_PLACEMENT,
  PERFORMANCE_FILTER_SELECT_MAX_MENU_HEIGHT,
  REFRESH_ICON_SIZE,
} from "../../../constants";
import { RadioOption, ValueContainer } from "../../../../../shared";
import refreshIcon from "../../../../../assets/images/icons8-refresh.gif";
import { generateImagePath } from "../../../../../shared/components/sidebarContainer/utility";
import { conversationSubFilterSelectStyles } from "./styles";

const ConversationSubFilterComponent = (props) => {
  const {
    refresh,
    selectedFilter,
    isSpinnerRunning,
    imagePathFromHub,
    setSelectedFilter,
  } = props;

  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
  };

  return (
    <div
      className="p-2 border-2 border-bottom d-flex align-items-center justify-content-between"
      data-testid="conversation-sub-filter"
    >
      <Select
        className="w-100"
        name="conversationSubFilter"
        options={conversationSubFilters}
        components={{
          IndicatorSeparator: () => null,
          Option: RadioOption,
          ValueContainer: ValueContainer,
        }}
        hideSelectedOptions={false}
        closeMenuOnSelect={true}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.value}
        onChange={handleFilterChange}
        isSearchable={false}
        maxMenuHeight={PERFORMANCE_FILTER_SELECT_MAX_MENU_HEIGHT}
        menuPlacement={MENU_PLACEMENT.AUTO}
        value={selectedFilter}
        styles={conversationSubFilterSelectStyles}
        isLoading={isSpinnerRunning}
      />
      <div>
        {isSpinnerRunning ? (
          <Image
            src={generateImagePath(imagePathFromHub, refreshIcon)}
            width={REFRESH_ICON_SIZE}
            fluid
            className="ms-2 text-dark"
          />
        ) : (
          <TbRefresh
            size={REFRESH_ICON_SIZE}
            role="button"
            name="refresh"
            className="ms-2"
            onClick={refresh}
            data-testid="refresh"
          />
        )}
      </div>
    </div>
  );
};

export default React.memo(ConversationSubFilterComponent);
